module.exports = __webpack_public_path__ + "img/concave-hexagon.eb7364a6.svg";